import { registerSW } from 'virtual:pwa-register'
import {sessionCache} from "~/common/useCache";

export default defineNuxtPlugin(() => {
  if (process.client) {

    // 서비스 워커 등록 전에 쿠키 값을 세션에 설정
    const userCookie = useCookie('user')
    if (userCookie.value) {
      sessionCache.set('userInfo', userCookie.value)
    }

    registerSW({
      immediate: true,
      onRegisteredSW(r: ServiceWorkerRegistration) {
        console.log('SW Registered:', r)
      },
      onRegisterError(error: Error) {
        console.error('SW registration error', error)
      }
    })
  }
})